/** biome-ignore-all lint/nursery/useExplicitType: Zod schema inference */
import { MAX_REMINDER_TIMES, REMINDER_TIME_REGEX } from '@repo/config';
import { z } from 'zod';

export const updateNotificationPreferencesV1BodySchema = z.object({
  notificationEnabled: z.boolean(),
  reminderTimes: z.array(z.string().regex(REMINDER_TIME_REGEX)).max(MAX_REMINDER_TIMES).optional(),
  timezone: z.string().min(1).nullable(),
});

export type IUpdateNotificationPreferencesV1Body = z.infer<
  typeof updateNotificationPreferencesV1BodySchema
>;
